import { isNumber } from 'validate.js'
import { authError, changePasswordRequest, setAppStateMessage, checkSession, authSetUserVerification } from '../store/actions';
import jwt_decode from 'jwt-decode';

class ParameterStorage {
    constructor(name) {
        this.name = name;
    }
    
    get() {
        let value = localStorage.getItem(this.name);
      try {
        value = value ? JSON.parse(value) : null;
      } catch {
        value = null;
      }

      return value;
    }

    save(value) {
        localStorage.setItem(this.name, JSON.stringify(value));
    }

    remove() {
        localStorage.removeItem(this.name);
    }

    isExpired(value) {
        const expiresAt = value && isNumber(value.expiresAt) ? parseInt(value.expiresAt) : 0;
        return (new Date()).getTime() > expiresAt;
    }
}

export const TokenStorage = new ParameterStorage('token');
export const UserStorage = new ParameterStorage('user');
export const LoginFormStorage = new ParameterStorage('login');

export const base64Encode = (str) => {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode('0x' + p1);
        }));
}

export const base64Decode = (str) => {
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

const parseAuth0Parameters = (params) => {
    const res = {};

    if (params.has('error')) {
        res['error'] = {
            code: params.get('error'),
            message: params.get('error_description'),
            state: params.get('state')
        };
    } else if (params.has('access_token')) {
        res['authToken'] = {
            access_token: params.get('access_token'),
            id_token: params.get('id_token'),
            type: params.get('token_type'),
            state: params.get('state'),
            scope: params.get('scope'),
            expires: +params.get('expires_in'),
            has_tmp_pass: null
        };

        if (res.authToken.id_token) {
            const decoded = jwt_decode(res.authToken.id_token);
            res.authToken.has_tmp_pass = !!decoded[window.location.origin + '/has_tmp_pass'];
        }
    }
    if (params.has('message') && params.has('success') && params.get('success') === 'false') {
        const error = {
            message: String(params.get('message')),
            code: null
        };
        if (error.message.indexOf('Access expired') > -1) {
            error.message = 'Access expired. Please type your email to resend verification email';
            error.code = 'access_expired';
        }
        res['error'] = error;
    } else if (params.has('message')) {
        res['message'] = params.get('message');
    }

    return res;
};

export const parseAuth0Result = (dispatch, state, history) => {
    let hash = window.location.hash;
    const search = String(window.location.search).replace(/^\?/, '');
    if (!hash && search && ( search.indexOf('supportSignUp=') > -1 || search.indexOf('success=') > -1)) {
        hash = search;
    }
    if (hash) {
        const params = new URLSearchParams(String(hash).replace(/^#/, ''));
        const query = new URLSearchParams(String(search));
        const parsed = parseAuth0Parameters(params);
        if (query.get('reset-password') === 'result') {
            
            const pwd = base64Decode(query.get('pwd'));
            
            if (parsed['error']) {
                dispatch(authError(parsed['error']));
                return true;
            } else if(parsed['authToken']) {
                // set password
                console.log('on change password');
                history.replace("/");
                changePasswordRequest(parsed.authToken.id_token, null, pwd, (err, res) => {
                    if (err) {
                        dispatch(setAppStateMessage({
                            type: 'error',
                            msg: err
                        }));
                        return ;
                    }
                    dispatch(setAppStateMessage({
                        msg: 'The password was set. Please login'
                    }));
                });
                return true;
            }
        }

        if (parsed.error) {
            if ((parsed.error.code === 'unauthorized' && String(parsed.error.message).indexOf('verify your email') > -1) 
                || parsed.error.code === 'access_expired') {
                dispatch(authSetUserVerification(true));
            }
            history.push('/');
            dispatch(authError(parsed.error));
            return true;
        }

        if (parsed.authToken) {
            history.push('/');
            dispatch(checkSession(parsed.authToken, () => {
                // history.push('/dashboard');
            }));
            return true;
        }

        if (parsed.message) {
            history.push('/');
            dispatch(setAppStateMessage({ msg: parsed.message }));
            return true;
        }
    }
};